import * as R from 'ramda'
import * as HttpRequest from '../Data/HttpRequest'
import {LoginForm} from '../Components/LoginForm/LoginFormState'
import {OrderOverviewRequestIdentifier} from '../Pages/OrderOverview/OrderOverviewFeedback'
import {
    OrderDetailsDownloadRequestIdentifier,
    OrderDetailsRequestIdentifier
} from '../Pages/OrderDetails/OrderDetailsFeedback'
import {
    OrderExportCreateDownloadRequestIdentifier,
    OrderExportCreateRequestIdentifier
} from '../Pages/OrderExportCreate/OrderExportCreateFeedback'
import {OrderCreateRequestIdentifier} from '../Pages/OrderCreate/OrderCreateFeedback'
import {PasswordChangeRequestIdentifier} from '../Pages/PasswordChange/PasswordChangeFeedback'
import {
    InquiryDetailsDownloadRequestIdentifier,
    InquiryDetailsRequestIdentifier
} from '../Pages/InquiryDetails/InquiryDetailsFeedback'
// tslint:disable-next-line
import {ProductCalculationOverviewRequestIdentifier} from '../Pages/ProductCalculationOverview/ProductCalculationOverviewFeedback'
// tslint:disable-next-line
import {ProductCalculationDetailsRequestIdentifier} from '../Pages/ProductCalculationDetails/ProductCalculationDetailsFeedback'
import {
    OrderExportOverviewDownloadRequestIdentifier,
} from '../Pages/OrderExportOverview/OrderExportOverviewFeedback'
// tslint:disable-next-line
import {ProductCalculationImportRequestIdentifier} from '../Pages/ProductCalculationImport/ProductCalculationImportFeedback'
import {Loop} from '@mazechazer/redux-loop'
import {State} from './State'
import {Action} from './Actions'
import {sendDownloadRequest, sendRequest} from '../Data/Http'
import {
    PrismaRequestDetailsDownloadRequestIdentifier,
    PrismaRequestDetailsRequestIdentifier
} from '../Pages/PrismaRequestDetails/PrismaRequestDetailsFeedback'
import {PageLoadIdentifier} from './PageLoadIdentifier'
import {InquiryOverviewRequestIdentifier} from '../Pages/InquiryOverview/InquiryOverviewFeedback'
import {PrismaRequestOverviewRequestIdentifier} from '../Pages/PrismaRequestOverview/PrismaRequestOverviewFeedback'

export interface Relogin {
    readonly failedPageLoadRequest: TaggedPageLoadRequest | null
    readonly failedRequests: TaggedRequest[]
    readonly failedDownloadRequests: TaggedDownloadRequest[]
    readonly modal: LoginForm
}

export interface TaggedPageLoadRequest {
    readonly httpRequest: HttpRequest.HttpRequest
    readonly identifier: PageLoadIdentifier
}

export interface TaggedRequest {
    readonly httpRequest: HttpRequest.HttpRequest
    readonly receiver: HttpResponseReceiver
}

export interface TaggedDownloadRequest {
    readonly httpRequest: HttpRequest.HttpRequest
    readonly filename: string
    readonly receiver: HttpDownloadResponseReceiver
}

export type HttpResponseReceiver =
    | OrderOverviewHttpResponse
    | OrderDetailsHttpResponse
    | OrderExportCreateHttpResponse
    | PasswordChangeResponse
    | CreateOrderHttpResponse
    | InquiryOverviewHttpResponse
    | InquiryDetailsHttpResponse
    | ProductCalculationOverviewHttpResponse
    | ProductCalculationDetailsHttpResponse
    | ProductCalculationImportHttpResponse
    | PrismaRequestDetailsHttpResponse
    | PrismaRequestOverviewHttpResponse

export interface OrderOverviewHttpResponse {
    readonly type: 'OrderOverviewHttpResponse'
    readonly identifier: OrderOverviewRequestIdentifier
}

export interface OrderDetailsHttpResponse {
    readonly type: 'OrderDetailsHttpResponse'
    readonly identifier: OrderDetailsRequestIdentifier
}

export interface OrderExportCreateHttpResponse {
    readonly type: 'OrderExportCreateHttpResponse'
    readonly identifier: OrderExportCreateRequestIdentifier
}

export interface CreateOrderHttpResponse {
    readonly type: 'CreateOrderHttpResponse'
    readonly identifier: OrderCreateRequestIdentifier
}

export interface PasswordChangeResponse {
    readonly type: 'PasswordChangeResponse'
    readonly identifier: PasswordChangeRequestIdentifier
}

export interface InquiryOverviewHttpResponse {
    readonly type: 'InquiryOverviewHttpResponse'
    readonly identifier: InquiryOverviewRequestIdentifier
}

export interface InquiryDetailsHttpResponse {
    readonly type: 'InquiryDetailsHttpResponse'
    readonly identifier: InquiryDetailsRequestIdentifier
}

export interface ProductCalculationOverviewHttpResponse {
    readonly type: 'ProductCalculationOverviewHttpResponse'
    readonly identifier: ProductCalculationOverviewRequestIdentifier
}
export interface ProductCalculationDetailsHttpResponse {
    readonly type: 'ProductCalculationDetailsHttpResponse'
    readonly identifier: ProductCalculationDetailsRequestIdentifier
}
export interface ProductCalculationImportHttpResponse {
    readonly type: 'ProductCalculationImportHttpResponse'
    readonly identifier: ProductCalculationImportRequestIdentifier
}
export interface PrismaRequestDetailsHttpResponse {
    readonly type: 'PrismaRequestDetailsHttpResponse'
    readonly identifier: PrismaRequestDetailsRequestIdentifier
}
export interface PrismaRequestOverviewHttpResponse {
    readonly type: 'PrismaRequestOverviewHttpResponse'
    readonly identifier: PrismaRequestOverviewRequestIdentifier
}

export type HttpDownloadResponseReceiver =
    | OrderDetailsHttpDownloadResponse
    | InquiryDetailsHttpDownloadResponse
    | OrderExportCreateHttpDownloadResponse
    | OrderExportOverviewHttpDownloadResponse
    | PrismaRequestDetailsHttpDownloadResponse

export interface OrderDetailsHttpDownloadResponse {
    readonly type: 'OrderDetailsHttpDownloadResponse'
    readonly identifier: OrderDetailsDownloadRequestIdentifier
}

export interface InquiryDetailsHttpDownloadResponse {
    readonly type: 'InquiryDetailsHttpDownloadResponse'
    readonly identifier: InquiryDetailsDownloadRequestIdentifier
}

export interface OrderExportCreateHttpDownloadResponse {
    readonly type: 'OrderExportCreateHttpDownloadResponse'
    readonly identifier: OrderExportCreateDownloadRequestIdentifier
}

export interface OrderExportOverviewHttpDownloadResponse {
    readonly type: 'OrderExportOverviewHttpDownloadResponse'
    readonly identifier: OrderExportOverviewDownloadRequestIdentifier
}

interface PrismaRequestDetailsHttpDownloadResponse {
    readonly type: 'PrismaRequestDetailsHttpDownloadResponse'
    readonly identifier: PrismaRequestDetailsDownloadRequestIdentifier
}

export function sendOutHttpRequest(
    httpRequest: HttpRequest.HttpRequest,
    receiver: HttpResponseReceiver,
    {state, effects}: Loop<State, Action>,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        return {
            state,
            effects:
                R.append(
                    sendRequest(
                        (result): Action => ({
                            type: 'HttpResponse',
                            httpRequest,
                            receiver,
                            result,
                        }),
                        HttpRequest.authorize(
                            state.session.authentication.token,
                            httpRequest)),
                    effects),
        }
    } else {
        return {state, effects}
    }
}

export function sendOutHttpDownloadRequest(
    httpRequest: HttpRequest.HttpRequest,
    filename: string,
    receiver: HttpDownloadResponseReceiver,
    {state, effects}: Loop<State, Action>,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        return {
            state,
            effects: [
                sendDownloadRequest(
                    (result): Action => ({
                        type: 'HttpDownloadResponse',
                        httpRequest,
                        filename,
                        receiver,
                        result,
                    }),
                    HttpRequest.authorize(
                        state.session.authentication.token,
                        httpRequest),
                    filename),
            ],
        }
    } else {
        return {state, effects}
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/HttpManagement.ts